import PlatformUtil from "../utils/PlatformUtil";
import AppLogRequester from "./AppLogRequester";
import WebLogRequester from "./WebLogRequester";

export default class LogRequester {
  appLogRequester: AppLogRequester;
  webLogRequester: WebLogRequester;

  constructor(webLogRequester: WebLogRequester, appLogRequester: AppLogRequester) {
    this.webLogRequester = webLogRequester;
    this.appLogRequester = appLogRequester;
  }

  send(requestJSON: RequestParams, isAsync: boolean): Promise<AsyncXMLHttpResolve | void> {
    if (PlatformUtil.isApp()) {
      this.appLogRequester.send(requestJSON);

      return Promise.resolve();
    }

    if (isAsync) {
      return this.webLogRequester.send(requestJSON);
    }

    this.webLogRequester.sendSync(requestJSON);

    return Promise.resolve();
  }
}
